import { useState, useEffect, useCallback } from 'react';
import styles from './PaymentSuccessPage.module.css';

const AUTO_CLOSE_SECONDS =
  Number(import.meta.env.VITE_PAYMENT_SUCCESS_AUTO_CLOSE_SECONDS) || 10;

export default function PaymentSuccessPage() {
  const [countdown, setCountdown] = useState(AUTO_CLOSE_SECONDS);
  const [closeBlocked, setCloseBlocked] = useState(false);

  const closeWindow = useCallback(() => {
    window.close();
    setTimeout(() => {
      if (!window.closed) {
        setCloseBlocked(true);
      }
    }, 300);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prev) => Math.max(0, prev - 1));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (countdown === 0) {
      closeWindow();
    }
  }, [countdown, closeWindow]);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') closeWindow();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [closeWindow]);

  return (
    <main className={styles.main}>
      <div className={styles.card}>
        <svg
          className={styles.checkmark}
          width="121"
          height="84"
          viewBox="0 0 121 85"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            opacity="0.1"
            d="M118.638 20.0208C121.762 16.8966 121.762 11.8313 118.638 8.7071L112.274 2.34316C109.15 -0.781046 104.084 -0.781055 100.96 2.34314L54.9981 48.305C53.436 49.8671 50.9034 49.8671 49.3413 48.305L32.3708 31.3345C29.2466 28.2103 24.1812 28.2103 21.057 31.3345L14.6931 37.6985C11.5689 40.8226 11.5689 45.8879 14.6931 49.0121L46.5127 80.8319C49.6369 83.9562 54.7023 83.9562 57.8265 80.832L118.638 20.0208Z"
            fill="#06A4F3"
          />
          <path
            d="M89.3174 4.22144C92.051 1.48816 96.4832 1.48802 99.2168 4.22144L105.58 10.5857C108.314 13.3194 108.314 17.7514 105.58 20.4851L44.7695 81.2966C42.0359 84.0302 37.6038 84.0301 34.8701 81.2966L3.0498 49.4763C0.316567 46.7426 0.316355 42.3104 3.0498 39.5769L9.41406 33.2136C12.1477 30.4799 16.5798 30.4799 19.3135 33.2136L36.2842 50.1833C38.2368 52.136 41.4029 52.136 43.3555 50.1833L89.3174 4.22144Z"
            stroke="#06A4F3"
            strokeWidth="2"
          />
        </svg>

        <h1 className={styles.title}>Payment successful!</h1>
        <p className={styles.description}>You can now close this window.</p>

        <p className={styles.countdown} aria-live="polite">
          {closeBlocked
            ? 'Please close this tab manually.'
            : `This window will automatically close in ${countdown} second${countdown !== 1 ? 's' : ''}`}
        </p>
      </div>
    </main>
  );
}
